import React, {useContext, useState, useEffect} from "react";
import {InputGroup, Form, Button, Container, FloatingLabel, Col, Row} from "react-bootstrap";
import {Context} from "../index";
import {getStore, getStores, editProfile} from "../http/userAPI";
import {AddressSuggestions} from "react-dadata";



// добавить апи на изменение данных, кроме email`a  если меняется имеил то нужно 
const Profile = () => {
    const {user} = useContext(Context)
    const [firstName, setFirstName] = useState(user.user.name)
    const [lastName, setLastName] = useState(user.user.lastName)
    const [email, setEmail] = useState(user.user.email)
    const [phone, setPhone] = useState(user.user.phoneNumber)
    const [city, setCity] = useState(user.user.city)
    const [address, setAddress] = useState({value: user.user.address, data: {geo_lat: user.user.latitude, geo_lon: user.user.longitude}})
    const [stores, setStores] = useState([])
    const [storeId, setStoreId] = useState({id: 'c68d733c-e253-11ec-0a80-01540008c7ec'})

    useEffect(() => {
        getStores(user).then(data => setStores(data))
        getStore(user).then(data => setStoreId(data))
    }, [])

    const alertPlaceholder = document.getElementById('liveAlertPlaceholder')
    const appendAlert = (message, type) => {
        const wrapper = document.createElement('div')
        wrapper.innerHTML = [
            `<div class="alert alert-${type} alert-dismissible fade show" role="alert">`,
            `   <div>${message}</div>`,
            '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
            '</div>'
        ].join('')

        alertPlaceholder.append(wrapper)
    }

    const click = async () => {
        try {
            let data = await editProfile(user, firstName, lastName, email, phone, city, address.value, address.data.geo_lat, address.data.geo_lon, storeId.id);
        } catch (e) {
            alert(e.response.data?.message)
        }

    }

    return (
        <Container style={{padding: "10px"}}>
            <div id="liveAlertPlaceholder"></div>

            <main>
                <div className="py-5 text-center">
                    <h2>Профиль</h2>
                </div>
                <div className="row g-5">
                    <div className="col-md-7 col-lg-12">
                        <h4 className="mb-3">Редактировать профиль</h4>
                        <Form className="needs-validation" noValidate>
                            
                                <Row className="mb-3">
                                    <Col xs={12} md={6} className="mb-3 mb-md-0">     
                                        <InputGroup>
                                            <InputGroup.Text>Имя</InputGroup.Text>
                                            <Form.Control
                                                required
                                                aria-label="Default"
                                                aria-describedby="inputGroup-sizing-default"
                                                type="text"
                                                id="firstName"
                                                value={firstName}
                                                onChange={e => setFirstName(e.target.value)}
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <InputGroup>
                                            <InputGroup.Text>Фамилия</InputGroup.Text>
                                            <Form.Control
                                                required
                                                aria-label="Default"
                                                aria-describedby="inputGroup-sizing-default"
                                                type="text"
                                                id="lastName"
                                                value={lastName}
                                                onChange={e => setLastName(e.target.value)}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text>Email</InputGroup.Text>
                                            <Form.Control
                                                required
                                                aria-label="Default"
                                                aria-describedby="inputGroup-sizing-default"
                                                type="text"
                                                id="email"
                                                value={email}
                                                onChange={e => setEmail(e.target.value)}
                                                disabled
                                            />
                                        </InputGroup>
                                </Row>
                                <Row className="mb-3">
                                    <Col xs={12} md={6} className="mb-3 mb-md-0">     
                                        <InputGroup>
                                            <InputGroup.Text>Город</InputGroup.Text>
                                            <Form.Control
                                                required
                                                aria-label="Default"
                                                aria-describedby="inputGroup-sizing-default"
                                                type="text"
                                                id="city"
                                                value={city}
                                                onChange={e => setCity(e.target.value)}
                                            />
                                        </InputGroup>               
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <InputGroup>
                                            <InputGroup.Text>Телефон</InputGroup.Text>
                                            <Form.Control
                                                required
                                                aria-label="Default"
                                                aria-describedby="inputGroup-sizing-default"
                                                type="text"
                                                id="phone"
                                                value={phone}
                                                onChange={e => setPhone(e.target.value)}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                                <InputGroup>
                                                    <InputGroup.Text>Адрес</InputGroup.Text>
                                                    <AddressSuggestions
                                                        containerClassName={"form-control"}
                                                        token="a199d8110c08dd0d938a91b102aefa65fcf11239"
                                                        value={address}
                                                        onChange={setAddress}
                                                        inputProps={{
                                                            className: 'w-100 border-0',
                                                            style: { outline: 'none', boxShadow: 'none' } // Убираем рамку через inline-стили
                                                    }}
                                                        // inputProps={{onChange: (e) => {
                                                        //         // setAddress({value: e.target.value})
                                                        //
                                                        // }}}
                                                    />
                                                </InputGroup>
                                </Row>                                
                            

                            {user.hasRoleShop && (
                               <>
                            <hr className="my-4"/>
                            <FloatingLabel controlId="floatingInputGrid" className="h6" label="Склад для перемещения по умолчанию">
                                <Form.Select aria-label="Склад для перемещения по умолчанию" value={storeId.id}
                                             onChange={(e) => {
                                                 setStoreId({id: e.target.value})
                                             }}>
                                    {stores.map((entry) =>
                                        <option value={entry.id} key={entry.id}>{entry.name}</option>
                                    )}
                                </Form.Select>
                            </FloatingLabel></>)}

                            <Button
                                className="w-100 btn btn-primary btn-lg"
                                // variant={"outline-success"}
                                onClick={() => { click().then(r => appendAlert('Профиль успешно обновлен', 'success'))}}
                            >
                                Сохранить
                            </Button> 
                            
                        </Form>
                    </div>
                </div>
            </main>
        </Container>
    );
};

export default Profile;